(function () {
        document.addEventListener('click', closeBanner);

        /**
         * @param {Event} event 
         */
        function closeBanner(event) {
            const banner = getBanner();
            if (banner && !banner.contains(event.target)) {
                const declineButton = /** @type {HTMLButtonElement | null} */(banner.querySelector("#shopify-pc__banner__btn-decline"));
                if (declineButton) {
                    declineButton.click()
                } else {
                    banner.remove()
                }
                document.removeEventListener("click", closeBanner)
            }
        }

        /**
         * @returns {HTMLElement | null}
         */
        function getBanner() {
            return document.getElementById('shopify-pc__banner');
        }

})()